export * from './TextField';
export * from './textFieldClasses';

import React from 'react';

import TextField, {type TextFieldProps} from './TextField';
import ReadOnlyTextField, {
	type ReadOnlyTextFieldProps,
} from './ReadOnlyTextField';

export {default as ReadOnlyTextField} from './ReadOnlyTextField';
export * from './ReadOnlyTextField';

type ExternalProps = TextFieldProps | ReadOnlyTextFieldProps;

type InternalProps = {
	readOnly?: boolean;
};

export default function ({readOnly, ...props}: InternalProps & ExternalProps) {
	return !readOnly ? (
		<TextField {...(props as TextFieldProps)} />
	) : (
		<ReadOnlyTextField {...(props as ReadOnlyTextFieldProps)} />
	);
}
